'use strict';

var d3 = require('d3');

/**
 * Container
 *
 * It's used to create group of charts, with shared elements (scales, params, groups etc.) and different data
 *
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var Container = function Container(d3Helper) {
  /**
   * @param xPropertyName - a property name used to find X value
   * @param elementFunctions - functions used for drawing inside of the container
   * @param scalesFunc - function used to prepare scales for a given container
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, elementFunctions, scalesFunc) {
    var scales, params;

    /**
     * Returns X for data
     * @param {Object} d - data item
     * @returns {number}
     */
    function getX(d) {
      return scales.xScale(d[xPropertyName]);
    }

    /**
     *
     * @param container
     */
    var group = function group(container) {
      var containersGroup = d3Helper.createGroupElement(container, 'containers');
      var containers = containersGroup.selectAll('.container').data(container.datum());
      containers.enter().append('g').attr('class', 'container');
      containers.exit().remove();
      containers.attr({
        'transform': function transform(d, i) {
          var x = getX(d, i);
          return x !== undefined ? 'translate(' + [x, 0] + ')' : null;
        }
      });
      containers.each(function (d) {
        var container = d3.select(this).data([d.containerData]);
        var p = {
          width: scales.xScale.rangeBand(),
          height: params.height,
          containerWidth: scales.xScale.rangeBand(),
          containerHeight: params.height,
          padding: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0
          }
        };
        var s = scalesFunc(p, d.containerData);
        elementFunctions.forEach(function (elementFunction) {
          container.call(elementFunction.params(p).scales(s));
        }, this);
      });
    };

    /**
     * Sets/gets circle's scales
     * @param value
     * @returns {group}
     */
    group.scales = function (value) {
      scales = value;
      return group;
    };

    /**
     * Sets/gets circle's params
     * @param value
     * @returns {group}
     */
    group.params = function (value) {
      params = value;
      return group;
    };
    return group;
  };
};
Container.$inject = ['d3Helper'];
module.exports = Container;